import {ErrorHandler, Injectable, Injector} from '@angular/core';
import {HttpErrorResponse} from '@angular/common/http';
import {ErrorFacadeService} from './error-facade.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AuthenticationService} from '@services/authentication.service';
import {delay} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorHandlerService implements ErrorHandler {

  private _chunkFailedMessage = /Loading chunk [\d]+ failed/;
  private _moduleFetchFailedMessage = /Failed to fetch dynamically imported module:\s+https?:\/\/\S+/;
  private _failedRegistrationMessage = /The operation is insecure./;

  constructor(private _injector: Injector) { }

  handleError(error: Error): void {
    const errorFacade = this._injector.get(ErrorFacadeService);
    const snackBar = this._injector.get(MatSnackBar);
    if (this._chunkFailedMessage.test(error.message) || this._moduleFetchFailedMessage.test(error.message)) {
      console.log('Loading chunck is failed');
      const snack = snackBar.open('Mise à jour disponible', 'Mettre à jour', {
        duration: 3000
      });
      snack
        .onAction()
        .subscribe(() => {
          window.location.reload();
        });
      snack
        .afterDismissed()
        .subscribe(() => {
          window.location.reload();
        });
      return;
    }
    if (error instanceof HttpErrorResponse) {
      // Server or connection error happened
      console.log('HTTP error', error, navigator.onLine);
      if (!navigator.onLine) {
        // Handle offline error
      } else {
        // Handle Http Error
        if (errorFacade.isKnownBusinessError(error)) {
          errorFacade.notifyBusinessProblem(error.error);
        } else {
          this.httpErrorManagement(error);
        }
      }
    } else {
      // Catch the service worker registration error -> no send to Sentry and no redirect to /error
      // Error => DOMException: "The operation is insecure."
      if (this._failedRegistrationMessage.test(error.message)) {
        return;
      }
      // Handle Client Error (Angular Error, ReferenceError...)
      console.log('An error not managed by the application occured', error);
      errorFacade.sendErrorToSentry(error).pipe(
        delay(1000)
      ).subscribe(errorId => location.replace(window.location.protocol + '//' + window.location.host + '/error.html?errorId=' + errorId));
    }
  }

  private httpErrorManagement(error: HttpErrorResponse) {
    if (error.status === 0){
      return;
    }
    const errorFacade = this._injector.get(ErrorFacadeService);
    errorFacade.sendErrorToSentry(error).subscribe((errorId) => this._injector.get(ErrorFacadeService).notifyTechnicalError(errorId));

    if (error.status === 401) {
      const authenticationService = this._injector.get(AuthenticationService);
      authenticationService.refreshAccessTokenIfNeeded();
    }
  }
}
